import styled from 'styled-components'

import MEDIA from 'constants/media'

export const CheckboxWithTooltip = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  label {
    width: 200px;
  }
  ${MEDIA.medium`
    label {
      width: 375px;
    }
  `}
`
